import { Box, CardMedia, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import reload_icon from "@/assets/icons/map/reload.svg"
import { options, modalStyles } from "./mockData"
import battery_low_icon from "@/assets/icons/map/battery_low.svg"
import { animated, useSpring } from "react-spring"
import { getOptions, getWrapperOptions } from "./utils"
import { useMemo } from "react"

const MobileModal = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 681px)");
  const isLargeDesktop = useMediaQuery("(max-width: 1679px)");

  const styles = useMemo(() => {
    if (isMobile) {
      return modalStyles.xs;
    };
    if (isLargeDesktop) {
      return modalStyles.lg;
    };
    return modalStyles.xl;
  }, [isMobile, isLargeDesktop]);

  const [gridStyles] = useSpring(() => getOptions(1), [])
  const [descriptionStyles] = useSpring(() => getOptions(2), [])
  const [headerStyles] = useSpring(() => getOptions(3), [])
  const [wrapperStyles] = useSpring(() => getWrapperOptions(isMobile ? 75 : (isLargeDesktop ? 130 : 165)), [isMobile, isLargeDesktop])
  const AnimatedWrapper = animated(({ children, ...props }) => (
    <Box
      {...props}
      sx={{
        overflow: "hidden",
        position: "absolute",
        boxSizing: "border-box",
        width: "90%",
        backgroundColor: theme.palette.common.white,
        zIndex: "3",
        marginX: "5%",
        boxShadow: "0px 6.31px 15.14px 0px #0000001A",
        ...styles.container
      }}
    >
      {children}
    </Box>
  ));

  const AnimatedContent = animated(({ children, ...props }) => (
    <Box
      {...props}
    >
      {children}
    </Box>
  ));

  return (
    <AnimatedWrapper style={wrapperStyles}>
      <AnimatedContent
        style={headerStyles}
        sx={{
          display: "flex",
          alignItems: "center",
          ...styles.header
        }}
      >
        <Box
          sx={{
            backgroundColor: "#47B4E3",
            ...styles.circle
          }}
        />
        <Typography
          component="span"
          sx={{
            flex: "1 1 auto",
            fontWeight: "700",
            ...styles.headerLabel
          }}
        >
          Kenworth W900
        </Typography>
        <CloseIcon
          sx={{
            color: "#B3B3B3",
            ...styles.closeIcon
          }}
        />
      </AnimatedContent>
      <AnimatedContent
        style={descriptionStyles}
        sx={{
          backgroundColor: "#F3F3F3",
          height: "fit-content",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          ...styles.description
        }}
      >
        <Typography
          component="span"
          sx={styles.descriptionLabel}
        >
          122 La Mesa, Victorville, CA 92392, USA
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Typography
            component="span"
            sx={{
              color: "#4D4D4D",
              ...styles.updateLabel
            }}
          >
            Last update: 13:47 PM
          </Typography>
          <Box
            sx={{
              backgroundColor: theme.palette.common.white,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxSizing: "border-box",
              ...styles.reloadIconContainer
            }}
          >
            <CardMedia 
              component="img"
              image={reload_icon}
              sx={styles.reloadIcon}
            />
          </Box>
        </Box>
      </AnimatedContent>
      <AnimatedContent 
        sx={styles.grid}
        style={gridStyles}
      >
        <Grid container spacing={1}>
          {options.map(({ icon, label }, index) => (
            <Grid
              item
              xs={3}
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <CardMedia 
                component="img"
                image={icon}
                sx={styles.gridItemIcon}
              />
              <Typography
                sx={{
                  color: "#4D4D4D",
                  textAlign: "center",
                  ...styles.gridItemLabel
                }}
              >
                {label}
              </Typography>
            </Grid>
          ))}

          <Grid item xs={6}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FF6B001A",
                ...styles.gridItemBatteryContainer
              }}
            >
              <CardMedia 
                component="img"
                image={battery_low_icon}
                sx={styles.gridItemBatteryIcon}
              />
              <Typography
                component="span"
                sx={{
                  color: "#4D4D4D",
                  ...styles.gridItemBatteryLabel
                }}
              >
                Low
              </Typography>
              <Typography
                component="span"
                sx={{
                  color: theme.palette.primary.main,
                  ...styles.gridItemBatteryLabelPercentages
                }}
              >
                19%
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </AnimatedContent>
    </AnimatedWrapper>
  );
};

export default MobileModal;
